/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#failPageWrap[_ngcontent-%COMP%]{\n    padding-top:1.74rem;\n}\n#wrap[_ngcontent-%COMP%]{\n    width:63%;\n    margin:1.1rem auto 0;\n    color:white;\n}\n#fail_picture[_ngcontent-%COMP%]{\n    width: 1.56rem;\n    height: 1.56rem;\n    margin: 0 auto;\n    text-align: center;\n    line-height: 1.56rem;\n    color: white;\n}\n#buttonWrap[_ngcontent-%COMP%]{\n    margin-top: -0.8rem;\n}\n#closeBtn[_ngcontent-%COMP%]{\n    display: block;\n    color: white;\n    text-align: center;\n    width: 3rem;\n    margin: 3rem auto 0;\n}\n.closeBtnBorder[_ngcontent-%COMP%]{\n    border: 1px white solid;\n    padding: 0.2rem;\n    border-radius: 0.08rem;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/fail/fail.component.css.shim.ngstyle.js.pre-build-optimizer.js